/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { roundDependencies } from './dependenciesRound.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createFloor } from '../../factoriesAny.js';
export var floorDependencies = {
  roundDependencies: roundDependencies,
  typedDependencies: typedDependencies,
  createFloor: createFloor
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesFloor.generated.js
// module id = 629
// module chunks = 0